import React from 'react'
import { Badge, Button, Dropdown, Icon, Menu, Popconfirm, Tooltip } from 'antd';
import { Text4 } from '../../../styles';
import { PermissionHoc } from '../../HOC';

const WritePermissableButton = PermissionHoc(Menu.Item, "MERCHANTS_WRITE", { is_component: true, fallbackComponent: null })
const ReadPermissableButton = PermissionHoc(Menu.Item, "MERCHANTS_READ", { is_component: true, fallbackComponent: null })
const InsightsPermissableButton = PermissionHoc(Menu.Item, "MERCHANTS_INSIGHTS", { is_component: true, fallbackComponent: null })
const CommissionPermissableButton = PermissionHoc(Menu.Item, "MERCHANTS_COMMISSION", { is_component: true, fallbackComponent: null })
const AllotedAccountReadButton = PermissionHoc(Menu.Item, "ALLOTED_ACCOUNT_READ", { is_component: true, fallbackComponent: null })

const KYC_STATUS = {
    1: {
        color: "yellow",
        label: "Pending",
        value: 1
    },
    2: {
        color: "green",
        label: "Completed",
        value: 2
    },
    3: {
        color: "red",
        label: "Rejected",
        value: 3
    }
}
export const renderMenuOverlay = (methods, record) => {

    return (
        <Menu>
            <ReadPermissableButton className="mr-1" size="small" onClick={() => methods.toggleDetailsDrawer({ ...record })}>Details</ReadPermissableButton>
            <CommissionPermissableButton className="mr-1" size="small" onClick={() => methods.toggleCommissionModal({ ...record })}>Charges</CommissionPermissableButton>
            {record.esc ?
                <CommissionPermissableButton className="mr-1" size="small" onClick={() => methods.toggleInstaCommissionModal({ ...record })}>Insta Collect Charges</CommissionPermissableButton>
                : null}
            {record.profile && record.profile.token && <WritePermissableButton className="mr-1" size="small" onClick={() => methods.openKYCPage({ ...record })}>KYC</WritePermissableButton>}
            <InsightsPermissableButton className="mr-1" size="small" onClick={() => methods.toggleInsightsDrawer({ ...record })}>Insights</InsightsPermissableButton>
            {!record.is_login_disabled ?
                <WritePermissableButton className="mr-1" size="small" onClick={() => methods.toggleResendPasswordModal({ ...record })}>Resend Password</WritePermissableButton>
                : null}
            {
                record.is_active == true ?
                    <ReadPermissableButton className="mr-1" size="small" onClick={() => methods.toggleDeactivateModal({ ...record })}>Deactivate</ReadPermissableButton> : null
            }
            {methods.is_enable_fund_allotment && <AllotedAccountReadButton className="mr-1" size="small" onClick={() => methods.toggleAllotedConnectedBankingDrawer({ ...record })}>Allotted Accounts</AllotedAccountReadButton>}

        </Menu>
    )
}

export const getMerchantsTableColumns = (methods) => [{
    title: "Business Name",
    key: "business_name",
    render: (record) => <Text4>{record.profile.business_name}</Text4>
}, {
    title: "Email ID",
    key: "email",
    render: (record) => <Text4>{record.email}</Text4>
}, {
    title: "Phone",
    key: "phone",
    render: (record) => <Text4>{record.phone}</Text4>
}, {
    title: "Account Number",
    key: "account_number",
    render: (record) => <Text4>{record.profile.account_number}</Text4>
}, {
    title: "KYC Status",
    key: "internal_kyc_status",
    render: (record) =>
        <div className='d-flex align-items-center'>
            <Badge color={KYC_STATUS[record.profile.internal_kyc_status].color} text={<Text4>{KYC_STATUS[record.profile.internal_kyc_status].label}</Text4>} />
            {record.profile.internal_kyc_status === 1 ?
                <div className="refresh-icon ml-2">
                    <Tooltip title="Fetch KYC status">
                        <Icon
                            type="sync"
                            spin={record.id == methods.kycMerchantID}
                            onClick={() => { (record.id != methods.kycMerchantID) && methods.getKycData({ ...record }) }}
                        />
                    </Tooltip>
                </div> : null}
        </div>
}, {
    title: "Actions",
    render: (record) => (
        <Dropdown overlay={renderMenuOverlay(methods, record)} >
            <Button>
                Actions <Icon type="down" />
            </Button>
        </Dropdown>
    ),
},];


export const merchantsFilterNodes = [{
    label: "Business Name",
    field: "business_name",
    placeholder: "Enter Business Name",
    inputType: "text",
    defaultValue: ""
}, {
    label: "Email ID",
    field: "email",
    placeholder: "Enter Email ID",
    inputType: "text",
    defaultValue: ""
}, {
    label: "Phone",
    field: "phone",
    placeholder: "Enter Phone",
    inputType: "text",
    defaultValue: ""
}, {
    label: "Account Number",
    field: "account_number",
    placeholder: "Enter Account Number",
    inputType: "text",
    defaultValue: ""
}, {
    label: "KYC Status",
    field: "kyc_status",
    placeholder: "Select KYC Status",
    inputType: "select",
    defaultValue: undefined,
    options: Object.keys(KYC_STATUS).map((type, index) => {
        let object = {};
        object.key = index;
        object.value = KYC_STATUS[type].value;
        object.label = (
            <Badge
                color={KYC_STATUS[type].color}
                text={<Text4>{KYC_STATUS[type].label}</Text4>}
            />
        );
        return object;
    }),
}];